import app from "@/common/plugins/vueInstance";
import BootstrapVue3 from "bootstrap-vue-3";

import "bootstrap-vue-3/dist/bootstrap-vue-3.css";

app.use(BootstrapVue3);
